module.exports = __webpack_public_path__ + "assets/img/faq-hero.69e674a8.jpg";